import react from "./icons/react.svg";
import html from "./icons/html.svg";
import css from "./icons/css.svg";
import bootstrap from "./icons/bootstrap.svg";
import javascript from "./icons/javascript.svg";
import redux from "./icons/redux.svg";
import node from "./icons/node-js.svg";
import express from "./icons/express.svg";
import mongodb from "./icons/mongodb.svg";
import firebase from "./icons/firebase.svg";
import postgresql from "./icons/postgresql.svg";
import google from "./icons/Google.ico"
import passport from "./icons/passport.png"
import jwt from "./icons/jwt.png"
import mailgun from "./icons/mailgun.svg"
import nodemailer from "./icons/nodemailer.png"
import expo from "./icons/expo.svg"
import socket from "./icons/socket.png"
import download from "./icons/download.svg"
import link from "./icons/link.svg"

import home from './watchuseek/1.png'
import login from './watchuseek/2.png'
import watches from './watchuseek/3.png'
import detail from './watchuseek/4.png'
import checkout from './watchuseek/5.png'
import orders from './watchuseek/6.png'
import profile from './watchuseek/7.png'

export const assets = {
    react,
    html,
    css,
    bootstrap,
    javascript,
    redux,
    node,
    express,
    mongodb,
    firebase,
    postgresql,
    google,
    passport,
    mailgun,
    jwt,
    nodemailer, 
    expo,
    socket,
    download,
    link
}

export const watchuseek = {
    home,
    login,
    watches,
    detail,
    checkout,
    orders,
    profile
}